module.exports = __webpack_public_path__ + "static/ifurniture-07390701ba32b2e93421a545bceed846.jpg";